import React, { useContext } from 'react';
import { MessageType } from '../../../core/localization';
import { LocaleCtx } from '../../../contexts/locale.context';

const Translate: React.FC<{ message: MessageType }> = ({ message }) => {
  const { translate } = useContext(LocaleCtx);
  return <>{translate(message)}</>;
};

export default Translate;
